<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="category_type_delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            
            <b-button @click="category_type_delete" variant="primary">{{ $t('simple.delete') }}</b-button>
            
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    export default {

        mounted: function () {
            // Component mounted
            console.log('Category Type Remove Modal mounted');
        },

        destroyed() {
            // Component Destroyed
            console.log('Category Type Remove Modal destroyed.');
        },

        data: function() {
             return  {

                category_types_api: '/api/v1/settings/category/types/',

             }
        },

        methods: {

            category_type_delete: async function(){

                // Loading start
                this.$wait.start('category_type_delete');

                await axios.delete(this.category_types_api + this.id)

                .then((response) => {

                    // Loading stop
                    this.$wait.end('category_type_delete');

                    // Show success
                    Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                    // Close modal
                    this.$close(true);


                })
                .catch((error) => {

                    // Loading stop
                    this.$wait.end('category_type_delete');

                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // Close modal
                    this.$close(true);


                });

            },
        },
    }
</script>